








































































































































































































































































































































































































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import DataTableInspectionPlan from "@/components/report/datatable/DataTableInspectionPlan.vue"
import Notification from "@/components/common/notification/Notification.vue"
import BoxDiagram from "@/components/common/diagram/BoxDiagram.vue"
import BoxDiagramButton from "@/components/common/diagram/BoxDiagramButton.vue"
import BoxDiagramUnitLists from "@/components/common/diagram/BoxDiagramUnitLists.vue"
import DropDownProject from "@/components/common/combobox/DropDownProject.vue"
import BreadcrumbsPath from "@/components/common/breadcrumbs/BreadcrumbsPath.vue"
import { ReportApi, ProjectApi, AuthenticateApi, PlanningTransferApi } from '@/api'
import { namespace } from 'vuex-class'

const Auth = namespace('authentication')

@Component({
    components: {
        DropDownProject,
        DataTableInspectionPlan,
        Notification,
        BoxDiagram,
        BoxDiagramButton, 
        BoxDiagramUnitLists,
        BreadcrumbsPath
    }
})
export default class Hierarchy extends Vue { 
    panel = 0
    projectLists = [] as any
    loading = false
    jsonData = {
        projectId: 0 as number,
    } as any
    isShow = false

    @Auth.State('auth') auth!: any

    headerHeirachy = {}
    unitListsCustomerTransferredAndAcceptCompleted = []
    unitListsCustomerTransferWithAdditionalConditions = []
    unitListsCustomerTransferredAndNotAccept = []
    unitListsCustomerTransferredButNotAcceptAndPJFinsh = []
    unitListsCustomerTransferredButNotAcceptAndPastDeadline = []
    unitListsCustomerTransferredButNotAcceptAndNotDeadline = []
    unitListsCustomerTransferredAndAcceptCompleted2 = []
    unitListsCustomerTransferWithAdditionalConditions2 = []
    unitListsCustomerNotCheck2 = []
    unitListsCustomerTransferredButNotAcceptAndPJFinsh2 = []
    unitListsCustomerTransferredButNotAcceptAndPastDeadline2 = []
    unitListsCustomerTransferredButNotAcceptAndNotDeadline2 = []
    unitListsGuarantee = []
    unitListsCustomerTransferAppointmentAndAccepted = []
    unitListsCustomerTransferAppointmentWithAdditionalConditions = []
    unitListsCustomerProcessTransferAndAccepted = []
    unitListsCustomerProcessTransferWithAdditionalConditions = []
    unitListsCustomerWaitInspec2 = []
    unitListsCustomerWaitInspec3 = []
    unitListsCustomerWaitInspec4 = []
    unitListsCustomerWaitCRInspec2 = []
    unitListsCustomerWaitCRInspec3 = []
    unitListsCustomerWaitCRInspec4 = []
    unitListsNoAcceptPJInspec2 = []
    unitListsNoAcceptPJInspec3 = []
    unitListsNoAcceptPJInspec4 = []
    UnitListsNoAcceptLatePJInspec2 = []
    UnitListsNoAcceptLatePJInspec3 = []
    UnitListsNoAcceptLatePJInspec4 = []
    unitListsCustomerNoCheckButCRChecked = []
    unitListsCustomerNoCheckButCRNotCheck = []
    unitListsRoomPJNoSendToCR = []

    isTransferAndCheck = false
    isTransferAndCheckAfterTransfer = false
    isNoTransferAndCheck = false
    isProcessAccept = false

    isShowReport = false


    btnIsTransferAndCheck () {
        this.isTransferAndCheck === true ? this.isTransferAndCheck = false : this.isTransferAndCheck = true 
        this.isTransferAndCheckAfterTransfer = false
        this.isNoTransferAndCheck = false
        this.isProcessAccept = false
    }

    btnIsTransferAndCheckAfterTransfer () {
        this.isTransferAndCheckAfterTransfer === true ? this.isTransferAndCheckAfterTransfer = false : this.isTransferAndCheckAfterTransfer = true 
        this.isTransferAndCheck = false
        this.isNoTransferAndCheck = false
        this.isProcessAccept = false
    }

    btnIsNoTransferAndCheck () {
        this.isNoTransferAndCheck === true ? this.isNoTransferAndCheck = false : this.isNoTransferAndCheck = true 
        this.isTransferAndCheck = false
        this.isTransferAndCheckAfterTransfer = false
        this.isProcessAccept = false
    }

    btnIsProcessAccept () {
        this.isProcessAccept === true ? this.isProcessAccept = false : this.isProcessAccept = true 
        this.isTransferAndCheck = false
        this.isTransferAndCheckAfterTransfer = false
        this.isNoTransferAndCheck = false
    }

    created () {
		this.startup()
	}

    async startup () {
        this.loading = true

        const getUserInfo = await AuthenticateApi.GetUserInfo()
            const hasMatchingPermission = getUserInfo?.permission.filter((filter) => filter.profileCode === "TFP-07" );

            if (hasMatchingPermission && hasMatchingPermission?.length <= 0) {
                localStorage.clear()
                window.location.reload()
            }

        this.projectLists = await ProjectApi.GetProjectLists()
        this.loading = false
    }

    async btnSearch () {
        this.loading = true

        if (this.jsonData.projectId === 0 || this.jsonData.projectId === "") {
            this.openNotification('กรุณาเลือกโครงการ', 'warning') 
            this.loading = false
            return
        }

        const getReportHeirachy = await ReportApi.GetReportHeirachy({ "projectId": parseInt(this.jsonData.projectId) })
        this.headerHeirachy = getReportHeirachy.headerReport

        const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnSearch",
                page: "Hierarchy",
                json_data: JSON.stringify(getReportHeirachy.headerReport),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)


        this.unitListsCustomerTransferredAndAcceptCompleted = getReportHeirachy.unitListsCustomerTransferredAndAcceptCompleted
        this.unitListsCustomerTransferWithAdditionalConditions = getReportHeirachy.unitListsCustomerTransferWithAdditionalConditions
        this.unitListsCustomerTransferredAndNotAccept = getReportHeirachy.unitListsCustomerTransferredAndNotAccept
        this.unitListsCustomerTransferredButNotAcceptAndPJFinsh = getReportHeirachy.unitListsCustomerTransferredButNotAcceptAndPJFinsh
        this.unitListsCustomerTransferredButNotAcceptAndPastDeadline = getReportHeirachy.unitListsCustomerTransferredButNotAcceptAndPastDeadline
        this.unitListsCustomerTransferredButNotAcceptAndNotDeadline = getReportHeirachy.unitListsCustomerTransferredButNotAcceptAndNotDeadline
        this.unitListsCustomerTransferredAndAcceptCompleted2 = getReportHeirachy.unitListsCustomerTransferredAndAcceptCompleted2
        this.unitListsCustomerTransferWithAdditionalConditions2 = getReportHeirachy.unitListsCustomerTransferWithAdditionalConditions2
        this.unitListsCustomerNotCheck2 = getReportHeirachy.unitListsCustomerNotCheck2
        this.unitListsCustomerTransferredButNotAcceptAndPJFinsh2 = getReportHeirachy.unitListsCustomerTransferredButNotAcceptAndPJFinsh2
        this.unitListsCustomerTransferredButNotAcceptAndPastDeadline2 = getReportHeirachy.unitListsCustomerTransferredButNotAcceptAndPastDeadline2
        this.unitListsCustomerTransferredButNotAcceptAndNotDeadline2 = getReportHeirachy.unitListsCustomerTransferredButNotAcceptAndNotDeadline2
        this.unitListsGuarantee = getReportHeirachy.unitListsGuarantee
        this.unitListsCustomerTransferAppointmentAndAccepted = getReportHeirachy.unitListsCustomerTransferAppointmentAndAccepted
        this.unitListsCustomerTransferAppointmentWithAdditionalConditions = getReportHeirachy.unitListsCustomerTransferAppointmentWithAdditionalConditions
        this.unitListsCustomerProcessTransferAndAccepted = getReportHeirachy.unitListsCustomerProcessTransferAndAccepted
        this.unitListsCustomerProcessTransferWithAdditionalConditions = getReportHeirachy.unitListsCustomerProcessTransferWithAdditionalConditions
        this.unitListsCustomerWaitInspec2 = getReportHeirachy.unitListsCustomerWaitInspec2
        this.unitListsCustomerWaitInspec3 = getReportHeirachy.unitListsCustomerWaitInspec3
        this.unitListsCustomerWaitInspec4 = getReportHeirachy.unitListsCustomerWaitInspec4
        this.unitListsCustomerWaitCRInspec2 = getReportHeirachy.unitListsCustomerWaitCRInspec2
        this.unitListsCustomerWaitCRInspec3 = getReportHeirachy.unitListsCustomerWaitCRInspec3
        this.unitListsCustomerWaitCRInspec4 = getReportHeirachy.unitListsCustomerWaitCRInspec4
        this.unitListsNoAcceptPJInspec2 = getReportHeirachy.unitListsNoAcceptPJInspec2
        this.unitListsNoAcceptPJInspec3 = getReportHeirachy.unitListsNoAcceptPJInspec3
        this.unitListsNoAcceptPJInspec4 = getReportHeirachy.unitListsNoAcceptPJInspec4
        this.UnitListsNoAcceptLatePJInspec2 = getReportHeirachy.UnitListsNoAcceptLatePJInspec2
        this.UnitListsNoAcceptLatePJInspec3 = getReportHeirachy.UnitListsNoAcceptLatePJInspec3
        this.UnitListsNoAcceptLatePJInspec4 = getReportHeirachy.UnitListsNoAcceptLatePJInspec4
        this.unitListsCustomerNoCheckButCRChecked = getReportHeirachy.unitListsCustomerNoCheckButCRChecked
        this.unitListsCustomerNoCheckButCRNotCheck = getReportHeirachy.unitListsCustomerNoCheckButCRNotCheck
        this.unitListsRoomPJNoSendToCR = getReportHeirachy.unitListsRoomPJNoSendToCR
        
        this.isShowReport = true
        this.loading = false
        
    }  

    openNotification (text: string, status: string) {
        const child = this.$refs.refNotifcation as any
        child.openNotification(text, status)
    }

    changeState (key: string, value: string) {
        this.jsonData[key] = value
    }

}
